
import VueSlickCarousel from 'vue-slick-carousel';
export default {
  name: 'QdapHomeVideoSectionDesktopComponent',

  components: { VueSlickCarousel },

  props: {
    data: {
      type: Object,
      default: () => ({
      }),
    },
  },

  data() {
    return {

      absolute: true,
      opacity: 0.5,
      overlay: false,

      isActive: true,
      settings: {
        "dots": true,
        "focusOnSelect": false,
        "infinite": true,
        "speed": 500,
        "slidesToShow": 3,
        "slidesToScroll": 3,
        "touchThreshold": 5,
        "responsive": [
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 3,
              "infinite": true,
              "dots": true
            }
          },
          {
            "breakpoint": 768,
            "settings": {
              "slidesToShow": 2,
              "slidesToScroll": 2
            }
          },
          {
            "breakpoint": 480,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1,
              "arrows": false
            }
          }
        ]
      }
    }
  },
}
